export interface SignatureNameParts {
  firstName?: string | null;
  hasMiddleName?: boolean | null;
  lastName?: string | null;
  middleName?: string | null;
  suffix?: string | null;
}

const MISSING_MIDDLE_NAME_PATTERN = /^(?:no\s*middle\s*name|null|undefined)$/i;

function normalizeNamePart(value: string | null | undefined): string {
  return value?.trim().replace(/\s+/g, ' ') ?? '';
}

/**
 * Builds the natural-order legal name used for styled signatures and their
 * audit data. PDF-only placeholders and serialized nullish middle-name values
 * must never become part of the adopted signature.
 */
export function formatSignatureName({
  firstName,
  hasMiddleName,
  lastName,
  middleName,
  suffix,
}: SignatureNameParts): string {
  const normalizedMiddleName = normalizeNamePart(middleName);
  const shouldIncludeMiddleName = hasMiddleName !== false && !MISSING_MIDDLE_NAME_PATTERN.test(normalizedMiddleName);

  return [
    normalizeNamePart(firstName),
    shouldIncludeMiddleName ? normalizedMiddleName : '',
    normalizeNamePart(lastName),
    normalizeNamePart(suffix),
  ]
    .filter(Boolean)
    .join(' ');
}
